// extracted by mini-css-extract-plugin
export default {"blueColor":"#4a90e2","paginationButton":"_3B6i3Twymkk08rT2sCLmFK"};